module.exports = __webpack_public_path__ + "img/aa_icon_touxiang.2663998b.png";